import { render, staticRenderFns } from "./CheckNotice.vue?vue&type=template&id=065ea8bc&"
import script from "./CheckNotice.vue?vue&type=script&lang=js&"
export * from "./CheckNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports